var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternetConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 76,
    viewBox: "0 0 95 76",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2422 70.0435C44.2278 73.3169 41.56 75.9559 38.2866 75.9414C35.0132 75.927 32.3743 73.2593 32.3887 69.9859C32.4032 66.7124 35.0709 64.0735 38.3443 64.0879C41.6177 64.1024 44.2566 66.7701 44.2422 70.0435Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.459 62.4289C32.9626 55.5936 43.5471 55.3917 50.2237 62.1116C53.2519 65.1543 57.9818 60.4677 54.9535 57.425C45.7966 48.196 30.7563 48.2537 21.758 57.699C18.8162 60.7994 23.5028 65.5436 26.459 62.4289Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33269 34.8433C15.3454 27.0563 26.1029 22.1534 38.1583 22.1246C50.0983 22.0958 61.8797 26.3353 70.6184 34.5549C73.7476 37.4822 78.4919 32.81 75.3483 29.8683C65.3262 20.4663 51.9009 15.4336 38.1871 15.4768C24.3292 15.5057 11.9999 21.1729 1.64609 30.1279C-1.59847 32.911 3.10255 37.6264 6.33269 34.8433Z",
    fill: "#6B7280"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2735 50.1292C20.3156 43.5968 28.7803 39.5015 37.7353 39.2996C46.9211 39.0833 55.804 42.8758 62.1922 49.437C65.1916 52.523 69.9215 47.822 66.922 44.7504C59.3658 36.9779 48.6371 32.3778 37.7642 32.6374C27.122 32.8825 16.7971 37.5835 9.58691 45.3994C6.67401 48.5286 11.3606 53.2873 14.2735 50.1292Z",
    fill: "#6B7280"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2821 22.297C96.0305 12.4079 89.4312 2.97379 79.5421 1.22535C69.6531 -0.523092 60.219 6.07621 58.4705 15.9653C56.7221 25.8544 63.3214 35.2885 73.2105 37.0369C83.0996 38.7854 92.5337 32.1861 94.2821 22.297Z",
    fill: "#FF3A30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8864 14.0524L81.3066 11.4727L69.7539 23.0254L72.3336 25.6051L83.8864 14.0524Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3336 11.4808L69.7539 14.0605L81.3067 25.6133L83.8864 23.0336L72.3336 11.4808Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetConnection);
export default __webpack_public_path__ + "static/media/internet-connection.dd63110b0133cde6529bf86af1c96d2f.svg";
export { ForwardRef as ReactComponent };